import { useTranslation } from 'react-i18next'
import { FormErrorType, TGameCard } from '../../types/commonTypes'
import styles from './GameRatingModal.module.css'
import { useOnEscPress } from '../../hooks/useOnEscPress'
import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll'
import { useFadeAnimation } from '../../hooks/FadeAnimation/useFadeAnimation'
import { SmallModal } from '../../common/components/Modal/SmallModal'
import { Form } from 'react-final-form'
import { useState } from 'react'
import classNames from 'classnames'
import { StarRatingButtons } from './StarRatingButtons'
import { TextAreaFormField } from '../../common/components/Form/TextAreaFormField/TextAreaFormField'

export type GameRatingModalProps = {
  game: TGameCard
  onClose: (game: TGameCard | null) => void
  onSaveClose: () => void
  saveGameRating: (text: string, stars: number) => void
}

export type RateGameForm = {
  stars: number
  text: string
}

export const GameRatingModal: React.FC<GameRatingModalProps> = ({ game, onClose, onSaveClose, saveGameRating }) => {
  const { t } = useTranslation()
  const [allowSubmitting, setAllowSubmitting] = useState<boolean>(false)
  useOnEscPress(() => onClose(null))
  useDisableBodyScroll()

  const { closeWithDelay } = useFadeAnimation()

  const initialValues = {
    stars: 0,
    text: '',
  }

  const validate = (values: RateGameForm): FormErrorType<RateGameForm> => {
    const err: any = {}
    if (values.stars === 0) {
      setAllowSubmitting(false)
      return { ...err, email: t('sponsored_games.download_modal.email_not_valid_error', 'Valid email is required') }
    }
    setAllowSubmitting(true)
    return err
  }

  const onSubmit = async (values: RateGameForm, e: any) => {
    saveGameRating(values.text, values.stars)
    closeWithDelay(350, () => onSaveClose())
  }

  const onCloseInternal = () => {
    closeWithDelay(350, () => onClose(null))
  }

  return (
    <>
      <Form<RateGameForm> initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
        {({ initialValues, values, handleSubmit }) => (
          <form className={classNames(styles.gameRatingForm)} onSubmit={handleSubmit}>
            <SmallModal
              onClose={onCloseInternal}
              headerText={t('rating.rating_modal.rating_header', 'Rating')}
              sendButtonText={t('common.save', 'Save')}
              allowSubmitting={allowSubmitting}
              iconName='star'
              sendButtonIsSubmit={true}
              onSubmit={handleSubmit}
            >
              <div className={styles.downloadSponsoredFormMainSection}>
                <div className={styles.modalContent}>
                  <div className={styles.modalDescriptionBox}>
                    <h4>"{game.gameName}"</h4>
                    <div className={styles.ratingContainer}>
                      <StarRatingButtons setValue={values.stars} />
                    </div>
                  </div>
                  <div className={styles.ratingTextArea}>
                    <TextAreaFormField
                      name='text'
                      label={t('rating.rating_modal.write_review_label', 'Write a review')}
                    />
                  </div>
                </div>
              </div>
            </SmallModal>
          </form>
        )}
      </Form>
    </>
  )
}
